import React from "react";
import Header from "../components/Header";

const Headerpage = () => {
  return (
    <header>
      <Header />
    </header>
  );
};

export default Headerpage;
